<table>
    <tr *ngFor="let day of days">
      <td class="p-2" [ngClass]="{'fw-bold': dayOfWeek === day.name}">
        {{ day.name }}
      </td>
      <td class="p-2" [ngClass]="{'fw-bold': dayOfWeek === day.name}">
        {{ day.hours }}
      </td>
    </tr>
  </table>
  